export default __webpack_public_path__ + "static/media/open-trash.af4b79eb.svg";